import { useNavigate } from "react-router";
import PgClock from "../../../components/shared-components/PgClock";
import { LOGO_IMG } from "../../../config/skinsettings";

type LogoProps = {
  width?: number;
  onClick?: () => void;
  marginLeft?: number;
  type?: string;
};

const Logo = ({ width, marginLeft, type, onClick }: LogoProps) => {
  let img = <img className="logo-img" src={LOGO_IMG} alt="PG Platform" />;
  const navigate = useNavigate();
  if (type) {
    switch (type) {
      case "t-1":
        img = (
          <img
            style={{ width: `${width}px`, marginLeft: `${marginLeft}px` }}
            className="logo-img"
            src="images/register-logo2@3x.png"
            alt="PG Platform"
          />
        );
        break;
      default:
        img = (
          <img
            style={{ width: `${width}px`, marginLeft: `${marginLeft}px` }}
            className="logo-img"
            src="images/logo.png"
            alt="PG Platform"
          />
        );
    }
  }

  return (
    <div
      className="pointer logo"
      onClick={() => {
        console.log("onclick", onClick);
        if (onClick) onClick();
        navigate("/");
      }}
    >
      {img}
    </div>
  );
};

export default Logo;
